import { Alternatives, Parameter } from "../../common/types/parameters";
import Dropdown from "./dropdown";
import { canHaveCommonSelectionInput } from "./util";

export default function MultiParameterDropdown(params: {
  parameters: Parameter[];
  disabled?: boolean;
  onValidChange?: (id: string, value: string) => void;
}) {
  return canHaveCommonSelectionInput(params.parameters) ? (
    <Dropdown
      inputId={params.parameters
        .map((parameter) => parameter.id)
        .toString()
        .replaceAll(",", "-")}
      defaultValue={params.parameters[0].value}
      alternatives={params.parameters[0].constraints as Alternatives}
      hideAlternativeValues={true}
      title={params.parameters[0].displayName}
      description={params.parameters[0].description}
      disabled={params.parameters.some((parameter) => !parameter.editable)}
      onValidChange={(id, value) => {
        if (params.onValidChange !== undefined) {
          let optionSuffix = JSON.parse(value).id.substring(
            params.parameters[0].id.length
          );
          params.parameters.forEach((parameter) => {
            params.onValidChange!(
              parameter.id,
              JSON.stringify(
                (parameter.constraints as Alternatives).find((alternative) =>
                  alternative.id.endsWith(optionSuffix)
                )
              )
            );
          });
        }
      }}
      includeVat={false}
    />
  ) : null;
}
